<template>
  <div>
    <div class="vx-row  mb-6" id="report-cards">
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4"
        style="padding-left:0.5rem;"
      >
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #ff9f43, #fdc38c)"
        >
          <div
            class="flex justify-between flex-row-reverse items-center yellow-card"
          >
            <span
              class="p-3 inline-flex rounded-full feather-icon select-none relative text-warning"
            >
              <feather-icon icon="ClipboardIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("TodayCustomersBaskets") }}</h6>
              <h5>15</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4"
        style="padding:0 0.5rem;"
      >
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #639, #aa75de)"
        >
          <div
            class="flex justify-between flex-row-reverse items-center purple-card"
          >
            <span
              class="p-3 inline-flex rounded-full feather-icon select-none relative"
            >
              <feather-icon icon="ClipboardIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">
                {{ $t("YesterdayCustomersBaskets") }}
              </h6>
              <h5>13</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4"
        style="padding:0 0.5rem;"
      >
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #17bbea, #8be0f9)"
        >
          <div
            class="flex justify-between flex-row-reverse items-center blue-card"
          >
            <span
              class="p-3 inline-flex rounded-full feather-icon select-none relative"
            >
              <feather-icon icon="ClipboardIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("TodayAgentsBaskets") }}</h6>
              <h5>14</h5>
            </div>
          </div>
        </vx-card>
      </div>
      <div
        class="vx-col w-full sm:w-1/2 md:w-1/4 lg:w-1/4 xl:w-1/4"
        style="padding-right:0.5rem;"
      >
        <vx-card
          content-color="#fff"
          card-background="linear-gradient(to left, #28c76f, #58d891)"
        >
          <div
            class="flex justify-between flex-row-reverse items-center green-card"
          >
            <span
              class="p-3 inline-flex rounded-full feather-icon select-none relative"
            >
              <feather-icon icon="ClipboardIcon" svgClasses="w-6 h-6" />
            </span>
            <div class="truncate">
              <h6 class="mb-4 font-bold">{{ $t("YesterdayAgentsBaskets") }}</h6>
              <h5>22</h5>
            </div>
          </div>
        </vx-card>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div
        class="vx-col lg:w-1/2 sm:w-1/2 w-full"
        style="padding-left:0.5rem!important"
      >
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <h1 class="tbl-ttl" style="background-color:#45b0ef;color:#fff">
            {{ $t("LatestConfirmedDraftOrders") }}
          </h1>
          <div class="custom-tbl strip">
            <vs-table :data="draftOrder" ref="table">
              <template slot="thead">
                <vs-th style="width:25%">{{ $t("Party") }}</vs-th>
                <vs-th style="width:17%">{{ $t("DraftOrderId") }}</vs-th>
                <vs-th style="width:19%">{{ $t("SiteOrderNumber") }}</vs-th>
                <vs-th style="width:19%">{{
                  $t("TotalAmountForPayment")
                }}</vs-th>
                <vs-th style="width:20%">{{ $t("CreateOn") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
                  <vs-td :data="data[indextr].draftOrderPartyInfoQueryDto.name">
                    {{ data[indextr].draftOrderPartyInfoQueryDto.name }}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>
                  <vs-td>
                    <!-- <span
                      v-if="
                        data[indextr].draftOrderContractQuery.contractId != null
                      "
                    >
                      {{
                        "APO-" +
                          (
                            "000" +
                            data[indextr].draftOrderContractQuery.contractId
                          ).substr(-3) +
                          ("0000" + data[indextr].basketId).substr(-4)
                      }}
                    </span> -->
                    <span>
                      {{ "APO-" + data[indextr].basketId }}
                    </span>
                  </vs-td>
                  <vs-td :data="data[indextr].totalAmountForPayment">
                    {{
                      Number(
                        data[indextr].totalAmountForPayment
                      ).toLocaleString()
                    }}
                    ریال
                  </vs-td>
                  <vs-td :data="data[indextr].createOn">
                    {{ data[indextr].createOn }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <div
        class="vx-col lg:w-1/2 sm:w-1/2 w-full"
        style="padding-right:0.5rem!important"
      >
        <div class="vx-card">
          <h1 class="tbl-ttl" style="background-color: #9f4eff;color: #fff;">
            {{ $t("LatestBaskets") }}
          </h1>
          <div class="custom-tbl strip">
            <vs-table :data="basket">
              <template slot="thead">
                <vs-th style="width:25%">{{ $t("Party") }}</vs-th>
                <vs-th style="width:17%">{{ $t("DraftOrderId") }}</vs-th>
                <vs-th style="width:19%">{{ $t("SiteOrderNumber") }}</vs-th>
                <vs-th style="width:19%">{{
                  $t("TotalAmountForPayment")
                }}</vs-th>
                <vs-th style="width:20%">{{ $t("CreateOn") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
                  <vs-td :data="data[indextr].basketCustomerInfo.name">
                    {{ data[indextr].basketCustomerInfo.name }}
                  </vs-td>
                  <vs-td :data="data[indextr].id">
                    {{ data[indextr].id }}
                  </vs-td>
                  <vs-td>
                    {{
                      "APO-" +
                        (
                          "000" + data[indextr].basketContractInfo.contractId
                        ).substr(-3) +
                        ("0000" + data[indextr].id).substr(-4)
                    }}
                  </vs-td>
                  <vs-td :data="data[indextr].totalAmount">
                    {{ Number(data[indextr].totalAmount).toLocaleString() }}
                    ریال
                  </vs-td>
                  <vs-td :data="data[indextr].closeTime">
                    {{ data[indextr].closeTime }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div
        class="vx-col lg:w-1/2 sm:w-1/2 w-full"
        style="padding-left:0.5rem!important"
      >
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <h1 class="tbl-ttl" style="background-color: #31ad71;color: #fff;">
            {{ $t("BestSellers") }}
          </h1>
          <div class="custom-tbl strip">
            <vs-table :data="bestSellers">
              <template slot="thead">
                <vs-th style="width:90%">{{ $t("ProductName") }}</vs-th>
                <vs-th style="width:10%">{{ $t("Count") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
                  <vs-td
                    :data="data[indextr].productName"
                    :title="data[indextr].productName"
                  >
                    {{ data[indextr].productName | truncate(75) }}
                  </vs-td>
                  <vs-td :data="data[indextr].count">
                    {{ data[indextr].count }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
      <div
        class="vx-col lg:w-1/2 sm:w-1/2 w-full"
        style="padding-right:0.5rem!important"
      >
        <div class="vx-card">
          <h1 class="tbl-ttl" style="background-color: #fb812a;color: #fff;">
            {{ $t("LeastSaleProducts") }}
          </h1>
          <div class="custom-tbl strip">
            <vs-table :data="leastSales">
              <template slot="thead">
                <vs-th style="width:90%">{{ $t("ProductName") }}</vs-th>
                <vs-th style="width:10%">{{ $t("Count") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
                  <vs-td
                    :data="data[indextr].productName"
                    :title="data[indextr].productName"
                  >
                    {{ data[indextr].productName | truncate(75) }}
                  </vs-td>
                  <vs-td :data="data[indextr].count">
                    {{ data[indextr].count }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
    <div class="vx-row mb-4">
      <div class="vx-col w-full">
        <div class="vx-card__collapsible-content vs-con-loading__container">
          <h1 class="tbl-ttl" style="background-color: #31ad71;color: #fff;">
            {{ $t("LatestSaledItems") }}
          </h1>
          <div class="custom-tbl strip">
            <vs-table :data="latestSaledItems" ref="latestSaledTable">
              <template slot="thead">
                <vs-th style="width:70%">{{ $t("ProductName") }}</vs-th>
                <vs-th style="width:20%">{{ $t("BasePrice") }}</vs-th>
                <vs-th style="width:10%">{{ $t("Count") }}</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="(tr, indextr) in data" :data="tr" :key="indextr">
                  <vs-td :data="data[indextr].productInfoName">
                    {{ data[indextr].productInfoName }}
                  </vs-td>
                  <vs-td :data="data[indextr].price">
                    {{ data[indextr].price.toLocaleString() }}ریال
                  </vs-td>
                  <vs-td :data="data[indextr].count">
                    {{ data[indextr].count }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.vs-table--tbody-table .tr-values td {
  padding: 4px 2px !important;
}

.tbl-ttl {
  text-align: center;
  background-color: #ddd;
  padding: 10px;
  font-size: 15px;
}

.strip .tr-values:nth-child(2n) {
  background-color: #ecebeb;
}

.strip .tr-values:hover {
  background-color: #c3c3c3;
}

.strip .tr-values:hover td {
  color: #1f1f1f;
}
</style>
<script>
import { mapGetters, mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  computed: {
    ...mapGetters({
      draftOrder: "draftOrder/list",
      basket: "basket/list",
      bestSellers: "reports/itemsList",
      leastSales: "reports/leastItemsList",
      latestSaledItems: "reports/latestSaledItems"
    })
  },
  mounted() {
    this.load();
  },
  methods: {
    ...mapActions({
      fetchDraftorderList: "draftOrder/fetchLatestRecords",
      fetchBasketList: "basket/fetchLatestRecords",
      fetchBestsellersItems: "reports/fetchBestsellersItems",
      fetchLeastSaleItems: "reports/fetchLeastSaleItems",
      fetchLatestSaledItems: "reports/fetchLatestSaledItems"
    }),
    load() {
      this.fetchDraftorderList();
      this.fetchBasketList();
      this.fetchBestsellersItems();
      this.fetchLeastSaleItems();
      this.fetchLatestSaledItems();
    }
  }
};
</script>
